import React from "react";
import { FormGroup } from "xsolla-uikit";

export default function PAantifraudComponents() {
  return (
    <div className="">
      <div className="xsui-content-block__entry">
        {/* <div className="afs-components__group-title">Advanced components</div> */}
        <div className="afs-components__advanced-group">
          <div className="afs-components__advanced-group-item">
            <div className="xsui-card">
              <div className="xsui-head xsui-head--appearance-primary xsui-head--indentation-md xsui-head--align-left">
                <div className="xsui-head__title"> In-game parameters</div>
              </div>
              <div className="xsui-form-group xsui-form-group--primary xsui-form-group--direction-column xsui-form-group--indentation-sm">
                <div className="xsui-form-group__entry">
                  Use in-game parameters (level, registration date, etc.) to
                  divide users into groups and apply its own filter to each
                  particular group.
                </div>
              </div>
              <div className="afs-card__footer">
                <button
                  className="xsui-button xsui-button--appearance-primary xsui-button--size-md"
                  type="button"
                >
                  <div className="xsui-button__wrapper">
                    <div className="xsui-button__content">Send request</div>
                  </div>
                </button>
              </div>
            </div>
          </div>
          <div className="afs-components__advanced-group-item">
            <div className="xsui-card">
              <div className="xsui-head xsui-head--appearance-primary xsui-head--indentation-md xsui-head--align-left">
                <div className="xsui-head__title"> AVS</div>
              </div>
              <div className="xsui-form-group xsui-form-group--primary xsui-form-group--direction-column xsui-form-group--indentation-sm">
                <div className="xsui-form-group__entry">
                  Authenticate paying users by cross-referencing their address
                  information with the card issuer’s records and decrease the
                  chargeback rate.
                </div>
              </div>
              <div className="afs-card__footer">
                <button
                  className="xsui-button xsui-button--appearance-primary xsui-button--size-md"
                  type="button"
                >
                  <div className="xsui-button__wrapper">
                    <div className="xsui-button__content">Send request</div>
                  </div>
                </button>
              </div>
            </div>
          </div>
          <div className="afs-components__advanced-group-item">
            <div className="xsui-card">
              <div className="xsui-head xsui-head--appearance-primary xsui-head--indentation-md xsui-head--align-left">
                <div className="xsui-head__title"> Retrospective payments</div>
              </div>
              <div className="xsui-form-group xsui-form-group--primary xsui-form-group--direction-column xsui-form-group--indentation-sm">
                <div className="xsui-form-group__entry">
                  Get a deep analysis of your past payment traffic to make
                  anti-fraud filters more suitable for your project whilst
                  keeping legitimate transactions flowing.
                </div>
              </div>
              <div className="afs-card__footer">
                <button
                  className="xsui-button xsui-button--appearance-primary xsui-button--size-md"
                  type="button"
                >
                  <div className="xsui-button__wrapper">
                    <div className="xsui-button__content">Send request</div>
                  </div>
                </button>
              </div>
            </div>
          </div>
        </div>
        <div className="afs-components__separator" />
        <div className="afs-components__group-title">Active components</div>
        <div className="afs-components__active-group">
          <div>
            <div className="xsui-card">
              <div className="xsui-status-dot xsui-status-dot--enabled">
                <div className="xsui-status-dot__icon" />
                <div className="xsui-status-dot__entry">Active</div>
              </div>
              <div className="xsui-head xsui-head--appearance-separated xsui-head--indentation-md xsui-head--align-left">
                <div className="xsui-head__title">
                  {" "}
                  Hybrid anti-fraud mechanism
                </div>
              </div>
              <div className="xsui-form-group xsui-form-group--primary xsui-form-group--direction-column xsui-form-group--indentation-sm">
                <div className="xsui-form-group__entry">
                  Get access to over 30 transaction parameters with the
                  combination of machine-learning and rule-based mechanisms. Set
                  different blocking rules for each group of users or payment
                  systems.
                </div>
              </div>
            </div>
          </div>
          <div>
            <div className="xsui-card">
              <div className="xsui-status-dot xsui-status-dot--enabled">
                <div className="xsui-status-dot__icon" />
                <div className="xsui-status-dot__entry">Active</div>
              </div>
              <div className="xsui-head xsui-head--appearance-separated xsui-head--indentation-md xsui-head--align-left">
                <div className="xsui-head__title"> Cross-game analytics</div>
              </div>
              <div className="xsui-form-group xsui-form-group--primary xsui-form-group--direction-column xsui-form-group--indentation-sm">
                <div className="xsui-form-group__entry">
                  Don't let the fraud detected in one game get to another with
                  special cross-game filters.
                </div>
              </div>
            </div>
          </div>
          <div>
            <div className="xsui-card">
              <div className="xsui-status-dot xsui-status-dot--enabled">
                <div className="xsui-status-dot__icon" />
                <div className="xsui-status-dot__entry">Active</div>
              </div>
              <div className="xsui-head xsui-head--appearance-separated xsui-head--indentation-md xsui-head--align-left">
                <div className="xsui-head__title"> Cross-game blacklisting</div>
              </div>
              <div className="xsui-form-group xsui-form-group--primary xsui-form-group--direction-column xsui-form-group--indentation-sm">
                <div className="xsui-form-group__entry">
                  Fight serial fraudsters by automatically blocking users
                  detected in fraudulent activity by Xsolla.
                </div>
              </div>
            </div>
          </div>
          <div>
            <div className="xsui-card">
              <div className="xsui-status-dot xsui-status-dot--enabled">
                <div className="xsui-status-dot__icon" />
                <div className="xsui-status-dot__entry">Active</div>
              </div>
              <div className="xsui-head xsui-head--appearance-separated xsui-head--indentation-md xsui-head--align-left">
                <div className="xsui-head__title"> Device fingerprinting</div>
              </div>
              <div className="xsui-form-group xsui-form-group--primary xsui-form-group--direction-column xsui-form-group--indentation-sm">
                <div className="xsui-form-group__entry">
                  Protect yourself from multi-account fraud by detecting the
                  user's device and limiting the number of accounts users can
                  pay from on this device.
                </div>
              </div>
            </div>
          </div>
          <div>
            <div className="xsui-card">
              <div className="xsui-status-dot xsui-status-dot--enabled">
                <div className="xsui-status-dot__icon" />
                <div className="xsui-status-dot__entry">Active</div>
              </div>
              <div className="xsui-head xsui-head--appearance-separated xsui-head--indentation-md xsui-head--align-left">
                <div className="xsui-head__title"> 3-D Secure</div>
              </div>
              <div className="xsui-form-group xsui-form-group--primary xsui-form-group--direction-column xsui-form-group--indentation-sm">
                <div className="xsui-form-group__entry">
                  Ensure the cardholder is actually participating in the
                  transaction, reducing the risk of chargebacks.
                </div>
              </div>
            </div>
          </div>
          <div>
            <div className="xsui-card">
              <div className="xsui-status-dot xsui-status-dot--enabled">
                <div className="xsui-status-dot__icon" />
                <div className="xsui-status-dot__entry">Active</div>
              </div>
              <div className="xsui-head xsui-head--appearance-separated xsui-head--indentation-md xsui-head--align-left">
                <div className="xsui-head__title"> Manual review</div>
              </div>
              <div className="xsui-form-group xsui-form-group--primary xsui-form-group--direction-column xsui-form-group--indentation-sm">
                <div className="xsui-form-group__entry">
                  Get manual review of suspicious transactions in case a
                  decision on them cannot be made automatically. Our specialists
                  will review it in several minutes.
                </div>
              </div>
            </div>
          </div>
          <div>
            <div className="xsui-card">
              <div className="xsui-status-dot xsui-status-dot--enabled">
                <div className="xsui-status-dot__icon" />
                <div className="xsui-status-dot__entry">Active</div>
              </div>
              <div className="xsui-head xsui-head--appearance-separated xsui-head--indentation-md xsui-head--align-left">
                <div className="xsui-head__title"> Additional verification</div>
              </div>
              <div className="xsui-form-group xsui-form-group--primary xsui-form-group--direction-column xsui-form-group--indentation-sm">
                <div className="xsui-form-group__entry">
                  Allow users to verify transactions by inputting a special
                  code, dividing genuinely fraudulent transactions from
                  legitimate ones.
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
